import React, { useState } from 'react';
import './SacredMarkersInfo.css';

const DATA = {
  alzhwar: {
    badge: '☸',
    label_en: 'Āḻvārs',
    label_hi: 'अल्झवार',
    tagline_en: 'The Vaishnava Poet-Saints of Tamil Nadu',
    tagline_hi: 'तमिलनाडु के वैष्णव कवि-संत',
    body_en: `The Āḻvārs (Azhwars) were Tamil saint-poets of the Vaishnava tradition who lived between approximately the 6th and 9th centuries CE (though traditional accounts place them much earlier). They were devoted to Vishnu and his various forms and incarnations, and their devotional hymns became the foundation of the Sri Vaishnava tradition.

The word Āḻvār is generally understood to mean "one who is immersed" in devotion to God. They were 12 in number. Refer the "The Saints" section for their names.

The Āḻvārs composed around 4,000 Tamil hymns, collectively known as the Nalayira Divya Prabandham. These hymns praise Vishnu and the temples where he is worshipped.

What is a Divya Desam?

A Divya Desam is a Vishnu temple that has been glorified in the hymns of the Āḻvārs and is mentioned in the Nalayira Divya Prabandham.

The term comes from: Divya = Divine; Desam (Desha) = Place or abode. Thus, a Divya Desam means "Divine Abode of Vishnu."

There are 108 Divya Desams in total. Distribution: 105 are in India, 1 is in Nepal, and 2 are considered celestial — Thirupparkadal and Srivaikunta.

Temples marked ☸ in this app are Divya Desams — temples sung about in the Nalayira Divya Prabandham.`,
    body_hi: `आल्वार (अल्झवार भी कहे जाते हैं) वैष्णव परंपरा के तमिल संत-कवि थे जो लगभग 6वीं से 9वीं शताब्दी ई. के बीच हुए (हालांकि पारंपरिक मान्यताएं उन्हें और पहले रखती हैं)। वे विष्णु और उनके विभिन्न रूपों और अवतारों के प्रति समर्पित थे, और उनके भक्ति भजन श्री वैष्णव परंपरा की नींव बने।

आल्वार शब्द का सामान्यतः अर्थ है "ईश्वर भक्ति में डूबे हुए।" वे 12 थे। उनके नाम "संत" अनुभाग में देखें।

आल्वारों ने लगभग 4,000 तमिल भजन रचे, जिन्हें सामूहिक रूप से नालयिर दिव्य प्रबंधम कहा जाता है। ये भजन विष्णु और उन मंदिरों की स्तुति करते हैं जहाँ उनकी पूजा होती है।

दिव्य देसम क्या है?

दिव्य देसम एक विष्णु मंदिर है जिसकी प्रशंसा आल्वारों के भजनों में की गई है और जिसका उल्लेख नालयिर दिव्य प्रबंधम में है।

यह शब्द आता है: दिव्य = पवित्र; देसम (देश) = स्थान या निवास। इस प्रकार दिव्य देसम का अर्थ है "विष्णु का पवित्र निवास।"

कुल 108 दिव्य देसम हैं: 105 भारत में, 1 नेपाल में, और 2 दिव्य लोक में — तिरुप्पार्कडल और श्रीवैकुंठ।

इस ऐप में ☸ से चिह्नित मंदिर दिव्य देसम हैं।`,
    saints_en: ['Nammalvar', 'Andal', 'Thirumangai Alvar', 'Periyalvar', 'Kulasekhara Alvar', 'Thirumalisai Alvar', 'Tondaradippodi Alvar', 'Thiruppaan Alvar', 'Poykai Alvar', 'Bhoothathalvar', 'Peyalvar', 'Madhurakavi Alvar'],
    saints_hi: ['नम्मालवार', 'आंडाल', 'तिरुमंगै अल्वार', 'पेरियालवार', 'कुलशेखर अल्वार', 'तिरुमलिसै अल्वार', 'तोंडरडिप्पोडि अल्वार', 'तिरुप्पाण अल्वार', 'पोयकै अल्वार', 'भूतत्तालवार', 'पेयालवार', 'मधुरकवि अल्वार'],
    scripture_en: 'Nalayira Divya Prabandham (4,000 verses)',
    scripture_hi: 'नालयिर दिव्य प्रबंधम (4,000 छंद)',
    sites_en: '108 Divya Desams',
    sites_hi: '108 दिव्य देसम',
    period_en: '6th – 9th century CE',
    period_hi: '6वीं – 9वीं शताब्दी ई.',
    color: 'alzhwar',
  },
  nayanmars: {
    badge: '🔱',
    label_en: 'Nayanmars',
    label_hi: 'नयनमार',
    tagline_en: 'The Shaiva Poet-Saints of Tamil Nadu',
    tagline_hi: 'तमिलनाडु के शैव कवि-संत',
    body_en: `The Nayanmars (Nayanars) were 63 Tamil Shaiva saint-poets who lived between the 6th and 8th centuries CE and composed devotional hymns to Shiva in Tamil. Their hymns were collected into the Tirumurai, a 12-volume canon of Tamil Shaiva scripture, with the first seven volumes (the Thevaram) composed by the three most celebrated Nayanmars: Thirugnana Sambandar, Appar (Thirunavukkarasar), and Sundarar.

The Nayanmars sang about specific Shiva temples, and the shrines they glorified in verse came to be called Paadal Petra Sthalams ("Places Sung in Praise") — 276 such temples are recognised, nearly all in Tamil Nadu, with a few in Andhra Pradesh and Sri Lanka. Visiting these temples and chanting the Thevaram verses within them is considered among the highest acts of Shaiva devotion.

The Nayanmars came from every stratum of society — farmers, kings, merchants, a woman (Karaikkal Ammaiyar), even a washerman and an untouchable — embodying the tradition's radical social openness. Their stories of devotion, collected in the Periya Puranam by Sekkizhar, are as important to Tamil Shaivism as the hymns themselves.

Temples marked 🔱 in this app are Paadal Petra Sthalams — temples sung in the Thevaram.`,
    body_hi: `नयनमार (नायनार) 63 तमिल शैव संत-कवि थे जो 6वीं से 8वीं शताब्दी ई. के बीच हुए और जिन्होंने तमिल में शिव को समर्पित भक्तिपूर्ण भजन रचे। उनके भजनों को तिरुमुरै में संकलित किया गया — तमिल शैव शास्त्र का 12-खंड संकलन। तिरुमुरै के पहले सात खंड (थेवारम) तीन सबसे प्रसिद्ध नयनमारों द्वारा रचित हैं: तिरुज्ञान संबंदर, अप्पर (तिरुनावुकरसर), और सुंदरर।

नयनमारों ने विशिष्ट शिव मंदिरों के बारे में गीत गाए, और जिन मंदिरों की उन्होंने छंदों में प्रशंसा की उन्हें पादल पेट्र स्थलम ("प्रशंसा में गाए गए स्थल") कहा जाता है — 276 ऐसे मंदिर मान्यता प्राप्त हैं।

नयनमार समाज के हर वर्ग से आए — किसान, राजा, व्यापारी, एक महिला (करइक्काल अम्मैयार), यहां तक कि एक धोबी और एक अस्पृश्य — जो परंपरा के मूलगामी सामाजिक खुलेपन को व्यक्त करते हैं।

इस ऐप में 🔱 से चिह्नित मंदिर पादल पेट्र स्थलम हैं।`,
    saints_en: ['Thirugnana Sambandar', 'Appar (Thirunavukkarasar)', 'Sundarar', 'Manikkavasagar', 'Karaikkal Ammaiyar', 'Kannappa Nayanar', 'Cheran Perumaal Nayanar', 'Siruthondar', 'Nandanar', 'Thiruneela Kanda Nayanar'],
    saints_hi: ['तिरुज्ञान संबंदर', 'अप्पर (तिरुनावुकरसर)', 'सुंदरर', 'माणिक्कवासगर', 'करइक्काल अम्मैयार', 'कन्नप्प नयनार', 'चेरन पेरुमाल नयनार', 'सिरुथोंदर', 'नंदनार', 'तिरुनीलकंठ नयनार'],
    scripture_en: 'Tirumurai — Thevaram (6,000+ verses)',
    scripture_hi: 'तिरुमुरै — थेवारम (6,000+ छंद)',
    sites_en: '276 Paadal Petra Sthalams',
    sites_hi: '276 पादल पेट्र स्थलम',
    period_en: '6th – 8th century CE',
    period_hi: '6वीं – 8वीं शताब्दी ई.',
    color: 'nayanmars',
  },
};

function MarkerCard({ id, lang }) {
  const [expanded, setExpanded] = useState(false);
  const d = DATA[id];
  const L = (en, hi) => lang === 'en' ? en : hi;

  return (
    <article className={`smi-card smi-${d.color}`}>
      <div className="smi-card-header" onClick={() => setExpanded(o => !o)}>
        <span className="smi-badge">{d.badge}</span>
        <div className="smi-titles">
          <h3 className="smi-title">{L(d.label_en, d.label_hi)}</h3>
          <p className="smi-tagline">{L(d.tagline_en, d.tagline_hi)}</p>
        </div>
        <div className="smi-meta-pills">
          <span className="smi-pill">{L(d.period_en, d.period_hi)}</span>
          <span className="smi-pill">{L(d.sites_en, d.sites_hi)}</span>
        </div>
        <span className="smi-chevron">{expanded ? '▲' : '▼'}</span>
      </div>

      {expanded && (
        <div className="smi-body fade-in">
          <div className="smi-columns">
            <div className="smi-text">
              {L(d.body_en, d.body_hi).split('\n\n').map((para, i) => (
                <p key={i}>{para}</p>
              ))}
            </div>
            <div className="smi-sidebar-info">
              <div className="smi-info-block">
                <span className="smi-info-label">{L('Scripture', 'ग्रंथ')}</span>
                <span className="smi-info-value">{L(d.scripture_en, d.scripture_hi)}</span>
              </div>
              <div className="smi-info-block">
                <span className="smi-info-label">{L('Sacred Sites', 'पवित्र स्थल')}</span>
                <span className="smi-info-value">{L(d.sites_en, d.sites_hi)}</span>
              </div>
              <div className="smi-info-block">
                <span className="smi-info-label">{L('Period', 'काल')}</span>
                <span className="smi-info-value">{L(d.period_en, d.period_hi)}</span>
              </div>
              <div className="smi-saints-block">
                <span className="smi-info-label">{L('The Saints', 'संत')}</span>
                <div className="smi-saints-list">
                  {L(d.saints_en, d.saints_hi).map((s, i) => (
                    <span key={i} className="smi-saint-chip">{s}</span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </article>
  );
}

export default function SacredMarkersInfo({ lang }) {
  const L = (en, hi) => lang === 'en' ? en : hi;
  return (
    <section className="smi-section">
      <h2 className="smi-section-heading">
        {L('Sacred Poet-Saint Traditions', 'पवित्र कवि-संत परंपराएं')}
      </h2>
      <p className="smi-section-sub">
        {L(
          'Temples marked ☸ or 🔱 belong to ancient devotional lineages whose hymns are still sung today.',
          '☸ या 🔱 से चिह्नित मंदिर प्राचीन भक्ति परंपराओं से संबंधित हैं जिनके भजन आज भी गाए जाते हैं।'
        )}
      </p>
      <div className="smi-cards">
        <MarkerCard id="alzhwar" lang={lang} />
        <MarkerCard id="nayanmars" lang={lang} />
      </div>
    </section>
  );
}
